// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

/*
 * In development mode, to ignore zone related error stack frames such as
 * `zone.run`, `zoneDelegate.invokeTask` for easier debugging, you can
 * import the following file, but please comment it out in production mode
 * because it will have performance impact when throw error
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.

export enum AuthMode {
  Azure = "Azure",
  AWS = "Cognito"
}

export const environment = {
  production: false,
  version: "1.4",
  envName: "dev",
  aws: {
    cognito: {
      // PROD
      ClientId: "", // PROD
      UserPoolId: "", // PROD
      AppWebDomain: "", //"lwasantospoc",

      TokenScopesArray: [], // e.g.['phone', 'email', 'profile','openid', 'aws.cognito.signin.user.admin']
      RedirectUriSignIn: "",
      RedirectUriSignOut: "",
      IdentityProvider: "", //'<TODO: add identity provider you want to specify>', // e.g. 'Facebook',
      AdvancedSecurityDataCollectionFlag: false, // boolean value indicating whether you want to enable advanced security data collection
      responseType: "code", // or 'token', note that REFRESH token will only be generated when the responseType is code
      Storage: localStorage, // OPTIONAL e.g. new CookieStorage(), to use the specified storage provided
      region: ""
    }
  },
  azurePortalConfig: {
    tenant: "santos.onmicrosoft.com",
    clientId: "b6c124b0-0fa4-4306-b181-64e1be2d39cf",
    postLogoutRedirectUri: "https://sap-dma.santos.com/",
    redirectUri: "https://sap-dma.santos.com/",
    cacheLocation: "localStorage",
    //apiEndpoint: "https://santoswebappsapi.santos.com/swausip-uat/",
     apiEndpoint: "https://santoswebappsapi.santos.com/swausip/",
    subscription: ""
  },
  currentAuthMode: AuthMode.Azure
};

export const LibraryConfig = {
  subscriptionKey: environment.azurePortalConfig.subscription,
  formApiUrl: environment.azurePortalConfig.apiEndpoint
};